'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var twig = require('twig').twig;
var tpl = require('actions/lanAllowVpn/static.html');

module.exports = BaseStaticView.extend({
  template: twig({data: tpl}),
});
